// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BottomArea_container__FuqhX {
    display: flex;
    gap: 30px;
    max-width: 95%;
    margin: auto;
    padding: 20px;
    background: #000000;
    color: white;
    border-radius: 20px;
  }
  
  .BottomArea_mainBlog__JxT2t {
    flex: 2 1;
    background: #000;
    padding: 20px;
    border-radius: 10px;
  }
  
  .BottomArea_mainImage__FOJRL {
    width: 100%;
    border-radius: 10px;
    object-fit: cover;
    height: 300px;
  }
  
  .BottomArea_title__iUgDr {
    font-size: 26px;
    font-weight: bold;
    margin: 15px 0;
  }
  
  .BottomArea_meta__lwnkG {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    color: #ccc;
  }
  
  .BottomArea_avatar__sqES4 {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  
  .BottomArea_content__Dz8gt {
    margin: 15px 0;
    font-size: 16px;
    line-height: 1.5;
  }
  
  .BottomArea_viewPost__\\+0HQf {
    color: red;
    text-decoration: none;
    font-weight: bold;
    display: inline-block;
    margin-top: 10px;
    cursor: pointer;
  }
  
  .BottomArea_sideBlogs__jjU3K {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  
  .BottomArea_sideBlog__ez\\+xh {
    display: flex;
    gap: 15px;
    align-items: center;
    background: #222;
    padding: 10px;
    border-radius: 8px;
    transition: background 0.3s ease;
    cursor: pointer;
    border: none;
    text-align: left;
    width: 100%;
  }
  
  .BottomArea_sideBlog__ez\\+xh:hover {
    background: #444;
  }
  
  .BottomArea_sideImage__9oOID {
    width: 100px;
    height: 80px;
    border-radius: 5px;
    object-fit: cover;
  }
  
  .BottomArea_sideTitle__t-kiM {
    font-size: 16px;
    font-weight: bold;
    color: white;
  }
  
  .BottomArea_sideDate__PaX2l {
    font-size: 12px;
    color: rgb(255, 255, 255);
  }
  
  .BottomArea_loading__Mw7Ny {
    text-align: center;
    font-size: 18px;
    color: red;
  }
  
  /* Responsive adjustments */
  @media (max-width: 768px) {
    .BottomArea_container__FuqhX {
      flex-direction: column;
      gap: 20px;
      padding: 15px;
    }
  
    .BottomArea_mainImage__FOJRL {
      height: 250px;
    }
  
    /* Arrange side blog cards in one column (one card per row) */
    .BottomArea_sideBlogs__jjU3K {
      flex-direction: column;
    }
  
    .BottomArea_sideBlog__ez\\+xh {
      width: 100%;
      flex: none;
    }
  }
  
  @media (max-width: 480px) {
    .BottomArea_mainImage__FOJRL {
      height: 200px;
    }
  
    .BottomArea_title__iUgDr {
      font-size: 22px;
    }
  
    .BottomArea_meta__lwnkG {
      font-size: 12px;
    }
  
    .BottomArea_content__Dz8gt {
      font-size: 14px;
    }
  
    .BottomArea_sideImage__9oOID {
      width: 80px;
      height: 60px;
    }
  
    .BottomArea_sideTitle__t-kiM {
      font-size: 14px;
    }
  
    .BottomArea_sideDate__PaX2l {
      font-size: 10px;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/Blogs/Components/CSS/BottomArea.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,cAAc;IACd,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,qBAAqB;IACrB,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,UAAU;EACZ;;EAEA,2BAA2B;EAC3B;IACE;MACE,sBAAsB;MACtB,SAAS;MACT,aAAa;IACf;;IAEA;MACE,aAAa;IACf;;IAEA,6DAA6D;IAC7D;MACE,sBAAsB;IACxB;;IAEA;MACE,WAAW;MACX,UAAU;IACZ;EACF;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;EACF","sourcesContent":[".container {\n    display: flex;\n    gap: 30px;\n    max-width: 95%;\n    margin: auto;\n    padding: 20px;\n    background: #000000;\n    color: white;\n    border-radius: 20px;\n  }\n  \n  .mainBlog {\n    flex: 2;\n    background: #000;\n    padding: 20px;\n    border-radius: 10px;\n  }\n  \n  .mainImage {\n    width: 100%;\n    border-radius: 10px;\n    object-fit: cover;\n    height: 300px;\n  }\n  \n  .title {\n    font-size: 26px;\n    font-weight: bold;\n    margin: 15px 0;\n  }\n  \n  .meta {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 14px;\n    color: #ccc;\n  }\n  \n  .avatar {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n  }\n  \n  .content {\n    margin: 15px 0;\n    font-size: 16px;\n    line-height: 1.5;\n  }\n  \n  .viewPost {\n    color: red;\n    text-decoration: none;\n    font-weight: bold;\n    display: inline-block;\n    margin-top: 10px;\n    cursor: pointer;\n  }\n  \n  .sideBlogs {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n  \n  .sideBlog {\n    display: flex;\n    gap: 15px;\n    align-items: center;\n    background: #222;\n    padding: 10px;\n    border-radius: 8px;\n    transition: background 0.3s ease;\n    cursor: pointer;\n    border: none;\n    text-align: left;\n    width: 100%;\n  }\n  \n  .sideBlog:hover {\n    background: #444;\n  }\n  \n  .sideImage {\n    width: 100px;\n    height: 80px;\n    border-radius: 5px;\n    object-fit: cover;\n  }\n  \n  .sideTitle {\n    font-size: 16px;\n    font-weight: bold;\n    color: white;\n  }\n  \n  .sideDate {\n    font-size: 12px;\n    color: rgb(255, 255, 255);\n  }\n  \n  .loading {\n    text-align: center;\n    font-size: 18px;\n    color: red;\n  }\n  \n  /* Responsive adjustments */\n  @media (max-width: 768px) {\n    .container {\n      flex-direction: column;\n      gap: 20px;\n      padding: 15px;\n    }\n  \n    .mainImage {\n      height: 250px;\n    }\n  \n    /* Arrange side blog cards in one column (one card per row) */\n    .sideBlogs {\n      flex-direction: column;\n    }\n  \n    .sideBlog {\n      width: 100%;\n      flex: none;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .mainImage {\n      height: 200px;\n    }\n  \n    .title {\n      font-size: 22px;\n    }\n  \n    .meta {\n      font-size: 12px;\n    }\n  \n    .content {\n      font-size: 14px;\n    }\n  \n    .sideImage {\n      width: 80px;\n      height: 60px;\n    }\n  \n    .sideTitle {\n      font-size: 14px;\n    }\n  \n    .sideDate {\n      font-size: 10px;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `BottomArea_container__FuqhX`,
	"mainBlog": `BottomArea_mainBlog__JxT2t`,
	"mainImage": `BottomArea_mainImage__FOJRL`,
	"title": `BottomArea_title__iUgDr`,
	"meta": `BottomArea_meta__lwnkG`,
	"avatar": `BottomArea_avatar__sqES4`,
	"content": `BottomArea_content__Dz8gt`,
	"viewPost": `BottomArea_viewPost__+0HQf`,
	"sideBlogs": `BottomArea_sideBlogs__jjU3K`,
	"sideBlog": `BottomArea_sideBlog__ez+xh`,
	"sideImage": `BottomArea_sideImage__9oOID`,
	"sideTitle": `BottomArea_sideTitle__t-kiM`,
	"sideDate": `BottomArea_sideDate__PaX2l`,
	"loading": `BottomArea_loading__Mw7Ny`
};
export default ___CSS_LOADER_EXPORT___;
